<template>
  <div
    class="room-main"
    style="background-color: #f4fbff"
    :class="[this.isIos === true ? 'room-main-ios' : '']"
  >
    <div
      class="room-video"
      :class="[this.isIos === true ? 'room-video-ios' : '']"
    >
      <p
        class="mobitorBitrate"
        style="position: fixed; margin-top: 125px"
        id="monitorVideoBitrate"
      ></p>
      <div
        ref="monitorViewport"
        class="monitorVideo"
        :class="{ 'monitorVideo-zoomed': zoomFlg }"
        @dblclick="changeZoomFlg"
        @touchend="handleVideoTouchEnd"
        :style="{ overflow: zoomFlg ? 'auto' : 'hidden', position: 'relative' }"
      >
        <div class="monitorVideo-content" :style="monitorVideoContentStyle">
          <video
            ref="video"
            id="remoteMonitorVideo"
            src=""
            autoplay
            playsinline
            @loadedmetadata="updateVideoContentSize"
            style="display: block; height: 100%; width: 100%; transform-origin: 0 0"
          ></video>
        </div>
        <audio
          id="remoteMonitorAudio"
          class="hide"
          src=""
          autoplay
          playsinline
        ></audio>
      </div>
    </div>
    <div class="room-tool">
      <div v-show="user_type === '5'" class="monitor-title">見守りカメラ</div>
      <div class="quitMonitor">
        <van-button round block type="danger" @click="quitRoom">
          見守りモードを終了
        </van-button>
      </div>
    </div>
    <canvas
      ref="canvas"
      style="display: none"
      width="500"
      height="400"
    ></canvas>
  </div>
</template>

<script>
import { useCaptureVideo } from "@/hooks";
import { onMounted, ref, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import { lockPatientMonitor, releasePatientMonitor } from "@/services";
export default {
  name: "monitorRoom",
  data() {
    return {
      isIos: true,
      user_type: "",
      zoomFlg: false,
      lastTouchEndTime: 0,
      renderedVideoWidth: 0,
      renderedVideoHeight: 0,
      resizeObserver: null,
    };
  },
  computed: {
    monitorVideoContentStyle() {
      const width = this.renderedVideoWidth || "100%";
      const height = this.renderedVideoHeight || "100%";
      return {
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        transform: this.zoomFlg ? "scale(3)" : "scale(1)",
        position: this.zoomFlg ? "absolute" : "relative",
        left: this.zoomFlg ? "0" : "auto",
        top: this.zoomFlg ? "0" : "auto",
      };
    },
  },
  components: {},
  created() {
    this.iosOrAndroid();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateVideoContentSize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateVideoContentSize);
    if (window.ResizeObserver && this.$refs.monitorViewport) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateVideoContentSize();
      });
      this.resizeObserver.observe(this.$refs.monitorViewport);
    }
    if (this.$route.query.type) {
      let type = this.$route.query.type;
      if (type == "startMonitor") {
        this.user_type = "5";
        // 患者主动进入监护模式
        this.$emit("monitor", { toPage: "monitor", method: "startMonitor" });
      } else if (type == "joinMonitor") {
        this.user_type = "4";
        // 医生进入监护模式详情页面
        this.$emit("monitor", {
          toPage: "monitor",
          method: "joinMonitor",
          id: this.$route.query.id,
          patient_id: this.$route.query.patient_id,
          ai_mode : this.$route.query.ai_mode,
        });
      }
    }
  },
  methods: {
    quitRoom() {
      this.$emit("monitor", {
        toPage: "monitor",
        method: "quitMonitor",
        fromPage: "monitorRoom",
      });
    },
    iosOrAndroid() {
      let url = window.location.href;
      if (url.indexOf("ios") !== -1) {
        console.log("URL contains 'ios'");
        this.isIos = true;
      } else {
        console.log("URL does not contain 'ios'");
        this.isIos = false;
      }
    },
    changeZoomFlg() {
      this.zoomFlg = !this.zoomFlg;
    },
    updateVideoContentSize() {
      const video = this.$refs.video;
      const viewport = this.$refs.monitorViewport;
      if (!video || !viewport) {
        return;
      }
      const viewportWidth = viewport.clientWidth;
      const viewportHeight = viewport.clientHeight;
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      if (!viewportWidth || !viewportHeight || !videoWidth || !videoHeight) {
        this.renderedVideoWidth = 0;
        this.renderedVideoHeight = 0;
        return;
      }
      const viewportRatio = viewportWidth / viewportHeight;
      const videoRatio = videoWidth / videoHeight;
      if (videoRatio > viewportRatio) {
        this.renderedVideoWidth = viewportWidth;
        this.renderedVideoHeight = viewportWidth / videoRatio;
        return;
      }
      this.renderedVideoHeight = viewportHeight;
      this.renderedVideoWidth = viewportHeight * videoRatio;
    },
    handleVideoTouchEnd() {
      const now = Date.now();
      if (now - this.lastTouchEndTime < 300) {
        this.changeZoomFlg();
        this.lastTouchEndTime = 0;
        return;
      }
      this.lastTouchEndTime = now;
    },

    onCaptureVideo() {},
  },
  watch: {
    screenWidth: function (n, o) {},
  },
};
</script>

<style scoped>
body {
  font-size: 16px;
  background-color: #f4fbff;
  -webkit-font-smoothing: antialiased;
}
.room-main {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: rgba(159, 161, 160, 0.726);
}
.room-main-ios {
  position: relative;
}
.myVideo {
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.monitorVideo {
  width: 100%;
  height: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
  margin: 0;
  background: #000;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
}
.monitorVideo-zoomed {
  display: block;
}
.monitorVideo-content {
  flex-shrink: 0;
  transform-origin: 0 0;
}
.room-monitor {
  margin-top: 10px;
  height: 100%;
  background-color: rgb(231, 229, 233);
  object-fit: cover;
  width: 100%;
}
.room-video {
  width: 100%;
  flex: 1;
  min-height: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}
.room-video-ios {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}
.video-all {
  width: 100%;
  height: 100%;
  position: relative;
}
.muted {
}
.quitMonitor {
  text-align: center;
  width: 200px;
  margin: 0 auto;
}

.room-tool {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
}

.monitor-title {
  text-align: center;
  font-size: 20px;
  margin-bottom: 12px;
}

.mobitorBitrate {
  position: absolute;
  bottom: 0;
  right: 20px;
  z-index: 1;
}
</style>
